export enum CoverageCreditIncentiveRewardType {
  StoreCredit = "store_credit",
  DiscountCode = "discount_code",
}
